const url = 'https://' + (process.env.VUE_APP_WP_HOST || 'eximusblog.altervista.org') + '/wp-json/wp/v2'

export class Post
{
	id = -1

	/**
	 * Default constructor
	 * 
	 * @param {Number} pk post primary key (id)
	 * @param {VuexStore} store vuex instance
	 */
	constructor(pk, store)
	{
		this.id = id
	}
	
	static all(params = null)
	{
		params = params ? '&' + (new URLSearchParams(params)).toString() : ''

		return new Promise((resolve, reject) => {

			let xhr = new XMLHttpRequest()
			xhr.open('GET', url + '/posts?per_page=40' + params)
			xhr.responseType = 'json'
			xhr.onreadystatechange = (ev) => {
				
				if (ev.target.readyState === xhr.DONE)
				{
					if (ev.target.status < 300)
						resolve(ev.target.response, ev.target.status)
					else
						reject(ev.target.response, ev.target.status)
				}
			}
			xhr.send()
		})
	}

	static tags(params = null)
	{
		params = params ? '?' + (new URLSearchParams(params)).toString() : ''

		return new Promise((resolve, reject) => {

			let xhr = new XMLHttpRequest()
			xhr.open('GET', url + '/tags' + params)
			xhr.responseType = 'json'
			xhr.onreadystatechange = (ev) => {
				
				if (ev.target.readyState === xhr.DONE)
				{
					if (ev.target.status < 300)
						resolve(ev.target.response, ev.target.status)
					else
						reject(ev.target.response, ev.target.status)
				}
			}
			xhr.send()
		})
	}

	static categories(params = null)
	{
		params = params ? '?' + (new URLSearchParams(params)).toString() : ''

		return new Promise((resolve, reject) => {

			let xhr = new XMLHttpRequest()
			xhr.open('GET', url + '/categories' + params)
			xhr.responseType = 'json'
			xhr.onreadystatechange = (ev) => {
				
				if (ev.target.readyState === xhr.DONE)
				{
					if (ev.target.status < 300)
						resolve(ev.target.response, ev.target.status)
					else
						reject(ev.target.response, ev.target.status)
				}
			}
			xhr.send()
		})
	}

	static getBySlug(slug, params = null)
	{
		params = new URLSearchParams({slug, ...params}).toString()

		return new Promise((resolve, reject) => {

			let xhr = new XMLHttpRequest()
			xhr.open('GET', url + '/posts?per_page=40&' + params)
			xhr.responseType = 'json'
			xhr.onreadystatechange = (ev) => {
				
				if (ev.target.readyState === xhr.DONE)
				{
					if (ev.target.status < 300)
						resolve(ev.target.response, ev.target.status)
					else
						reject(ev.target.response, ev.target.status)
				}
			}
			xhr.send()
		})
	}
}